/** @format */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  HomefieldIconLibraryModule,
  homefieldIconSignCancelOutline,
  HomefieldIconsLibraryService,
} from '@dsg-tech/homefield-angular-icons';

// Components
import { HomefieldSidePanelComponent } from './side-panel.component';

@NgModule({
  imports: [CommonModule, HomefieldIconLibraryModule],
  declarations: [HomefieldSidePanelComponent],
  exports: [HomefieldSidePanelComponent],
})
export class HomefieldSidePanelModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([homefieldIconSignCancelOutline]);
  }
}
